<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2b"><a id="page_x"></a><em>ACKNOWLEDGMENTS</em></h2>
<p class="indenti">I have benefitted greatly in the preparation of this monograph from the research and knowledge of two scholars. Larry W. Moses contributed a great deal to my understanding of Inner Asian history, the Mongol Empire, and the Golden Horde. Michel Roublev made available to me a typescript of his essay, “<em>The Scourge of God</em>,” in which he analyzes the impact of Mongol raids upon the medieval Russian economy and the Mongol role in the rise of Moscow. While Roublev’s methods, aims, and premises often differ strikingly from my own, I have found several of his conclusions persuasive. Neither Larry W. Moses nor Michel Roublev is responsible for the use I have made of his research.</p>
<p class="indenti">Financial assistance from the International Research and Exchanges Board during 1980–1981, when my participation in the scholarly exchange with the Soviet Union was precluded, permitted the writing of the basic draft of this book. Additional financial assistance during Fall 1981 enabled me to continue my research in the Soviet Union on the Senior Scholar/Ministry Exchange. I am also grateful to the Russian Institute of Columbia University for making me a Senior Fellow during Spring 1982 and providing both financial assistance and an office.</p>
<p class="indenti">I should also like to express my sincerest appreciation to Walter Michener for editorial assistance.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ack.vue?0bdfad0c